import React from "react";
import { fmtDate } from "@/lib/constants";

const what = (e) => [
  e.pages ? `${e.pages} page${e.pages === 1 ? "" : "s"}` : null,
  e.all_pages ? "every page" : null,
  e.buyer_deliveries ? `${e.buyer_deliveries} buyer deliver${e.buyer_deliveries === 1 ? "y" : "ies"}` : null,
  e.credit_codes?.length ? `link credit (${e.credit_codes.join(", ")})` : null,
].filter(Boolean).join(", ") || "nothing assigned";

// Employees row: who took over this person's pages, buyers and link credit, and whose they took over.
export function HandoverNote({ user, testId }) {
  const out = user.handed_over;
  const ins = user.took_over || [];
  if (!out && !ins.length) return null;
  return (
    <div className="mt-1 max-w-xs space-y-0.5 text-[10px] leading-snug text-zinc-600" data-testid={testId}>
      {out && (
        <div data-testid={`${testId}-out`}>
          Handed over to <b className="text-black">{out.to}</b> on {fmtDate(out.at)}: {what(out)}
        </div>
      )}
      {ins.map((e, i) => (
        <div key={`${e.from_id}-${e.at}`} data-testid={`${testId}-in-${i}`}>
          Took over from <b className="text-black">{e.from || "a removed employee"}</b> ({e.removed}) on {fmtDate(e.at)}: {what(e)}
        </div>
      ))}
    </div>
  );
}
